import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Text3D } from "@react-three/drei";

function NameText() {
  const textRef = useRef();

  useFrame(({ mouse }) => {
    if (textRef.current) {
      textRef.current.rotation.x = mouse.y * 0.1;
      textRef.current.rotation.y = mouse.x * 0.1;
    }
  });

  return (
    <mesh position={[0, 0, -100]} ref={textRef}>
      <Text3D
       font="/fonts/helvetiker_regular.typeface.json"
       size={1}
       height={0.2}
       position={[0, 0, 0]}
    >
       Jan Bím
       <meshStandardMaterial color="white" emissive="white" emissiveIntensity={0.5} />
       </Text3D>
    </mesh>
  );
}

export default NameText;